import { lazy } from "react";
import { RouteObject } from "react-router-dom";

// Assignment Results
const AssignmentResultsListPage = lazy(
  () =>
    import("@/features/admin-view/assignments-results/pages/student-progress")
);
const StudentIndividualAssignmentResultPage = lazy(
  () =>
    import(
      "@/features/admin-view/assignments-results/pages/student-individual-assignment-result"
    )
);
const StudentAssignmentDetailsPage = lazy(
  () =>
    import(
      "@/features/admin-view/assignments-results/pages/student-assignment-details"
    )
);
const AssignmentStudentsListPage = lazy(
  () =>
    import(
      "@/features/admin-view/assignments-results/pages/assignment-students-list"
    )
);
const StudentIcaresOverviewPage = lazy(
  () =>
    import(
      "@/features/admin-view/assignments-results/pages/student-icares-overview"
    )
);

const TestResultsPage = lazy(
  () => import("@/shared/testResults/pages/test-results-page")
);
const IslandsSubjectsListPage = lazy(
  () =>
    import(
      "@/features/admin-view/assignments-management/pages/islands-subjects-list"
    )
);

export const assignmentResultsRoutes: RouteObject[] = [
  {
    path: "/admin/assignment-results",
    element: <AssignmentResultsListPage />,
  },
  {
    path: "/admin/assignments-results/subjects-list/:islandId",
    element: <IslandsSubjectsListPage />,
  },
  {
    path: "/admin/assignments-results/:islandName",
    element: <StudentIndividualAssignmentResultPage />,
  },
  {
    path: "/admin/assignments-results/assignment-details",
    element: <StudentAssignmentDetailsPage />,
  },
  {
    path: "/admin/assignments-results/icares-overview",
    element: <StudentIcaresOverviewPage />,
  },
  {
    path: "/admin/assignments-results/assignment-students-list/:assignmentId",
    element: <AssignmentStudentsListPage />,
  },
  {
    path: "/admin/test-results/:studentId/:schoolYear",
    element: <TestResultsPage />,
  },
];
